/* Local behavior-denial mock. It mirrors the pursuit-vue contract and is only
 * enabled in development when VUE_APP_PURSUIT_MOCK is not explicitly false. */
import axios from 'axios'
import mockAsset from '@/assets/pursuit-detection-photo.png'
const fixtureImage = mockAsset

const MOCK_FLAG = process.env.VUE_APP_PURSUIT_MOCK
export const pursuitMockEnabled = process.env.NODE_ENV === 'development' && MOCK_FLAG !== 'false'

const image = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="640" height="360" viewBox="0 0 640 360"><rect width="640" height="360" fill="#061c29"/><path d="M0 280h640M0 220h640M120 0v360M420 0v360" stroke="#0b6a78" opacity=".45"/><rect x="230" y="92" width="150" height="140" fill="none" stroke="#00e9ef" stroke-width="3"/><circle cx="305" cy="160" r="38" fill="#ff25bd" opacity=".18"/><text x="24" y="332" fill="#7de8ed" font-family="monospace" font-size="18">MOCK PURSUIT DETECTION</text></svg>')

const imageUrl = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="640" height="360"><rect width="640" height="360" fill="#061c29"/><path d="M0 280h640M0 220h640M120 0v360M420 0v360" stroke="#0b6a78"/><rect x="230" y="92" width="150" height="140" fill="none" stroke="#00e9ef" stroke-width="3"/><circle cx="305" cy="160" r="38" fill="#ff25bd" opacity=".18"/></svg>')
const renderableImageUrl = imageUrl.replace(/^[image omitted]/, 'data:image/svg+xml;charset=UTF-8,')
const mockImageData = '<svg xmlns="http://www.w3.org/2000/svg" width="640" height="360"><rect width="640" height="360" fill="#061c29"/><path d="M0 280h640M0 220h640M120 0v360M420 0v360" stroke="#0b6a78"/><rect x="230" y="92" width="150" height="140" fill="none" stroke="#00e9ef" stroke-width="3"/><circle cx="305" cy="160" r="38" fill="#ff25bd" opacity=".18"/></svg>'
const mockImage = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(mockImageData)
const now = Date.now()
const robotCodes = ['BALL-001', 'BALL-002', 'BALL-003']
const activeOnlyRobotCode = robotCodes[0]
const conditionOnlyRobotCode = robotCodes[1]
const mockTargetId = 'ab6c5675-244a-463a-9785-2f9fa00699a6'
const mockOfflineFeedbackZh = '机器人持续离线，平台已自动关闭该行为拒止'
const mockOfflineFeedbackEn = 'Robot remains offline; the platform automatically closed this pursuit denial'
const state = {
  events: robotCodes.reduce((all, code, robotIndex) => {
    all[code] = Array.from({ length: 10 }, (_, index) => {
      const id = 'evt-mock-' + (robotIndex + 1) + '-' + (index + 1)
      const targetId = index === 0 ? mockTargetId : 'target-' + (robotIndex + 1) + '-' + (index + 1)
      const active = index === 0 && code !== conditionOnlyRobotCode
      return {
        eventId: id, targetId, eventStatus: active ? 'ACTIVE' : 'CANCELED', active,
        pursuitState: active ? 'TRACKING' : 'TRACKING', operationType: 'AUTHORIZE', operationStatus: 'ACK_OK', sourceReportTimestamp: now - index * 180000,
        sourceAnnotatedImageUrl: fixtureImage, lastFeedbackMessageZh: active ? mockOfflineFeedbackZh : '取消成功',
        lastFeedbackMessageEn: active ? mockOfflineFeedbackEn : 'Cancellation succeeded',
        startTime: now - index * 180000 - 30000, closeTime: active ? null : now - index * 180000,
        code
      }
    })
    return all
  }, {}),
  messages: robotCodes.reduce((all, code, robotIndex) => {
    all[code] = Array.from({ length: 10 }, (_, index) => ({
      reportTimestamp: now - index * 60000,
      annotatedImageUrl: fixtureImage,
      targets: Array.from({ length: index % 3 + 1 }, (_, targetIndex) => ({
        targetId: index === 0 && targetIndex === 0
          ? mockTargetId
          : 'target-' + (robotIndex + 1) + '-' + (index + 1) + '-' + (targetIndex + 1),
        className: targetIndex % 2 ? 'vehicle' : 'person', score: Number((0.91 - targetIndex * 0.04).toFixed(2))
      }))
    }))
    return all
  }, {}),
  operations: {},
  nextEvent: 20,
  nextOperation: 1000
}

const socketRegistry = []
const emitSocketEvent = (code, message) => {
  socketRegistry.slice().forEach(socket => {
    if (!socket.closed && socket.code === code) socket.onMessage(message)
  })
}
const updateOperation = (event, status, message, code) => {
  const operations = state.operations[event.eventId] || []
  const operation = operations[operations.length - 1]
  if (!operation) return
  operation.operationStatus = status
  operation.feedbackCode = code
  operation.feedbackMessageZh = message
  operation.feedbackMessageEn = message === '取消成功' ? 'Cancellation succeeded' : 'Authorization succeeded'
  operation.feedbackTimestamp = Date.now()
}
const normalizeImages = value => {
  if (Array.isArray(value)) return value.map(normalizeImages)
  if (value && typeof value === 'object') return Object.keys(value).reduce((result, key) => { result[key] = normalizeImages(value[key]); return result }, {})
  return typeof value === 'string' && value.indexOf('[image omitted]') === 0 ? mockAsset : value
}

const response = (data, message = '查询成功', messageENum = 'QUERY_SUCCESSFUL') => ({ code: 200, messageENum, message, data: normalizeImages(data), success: true })
const query = url => {
  const [, queryString = ''] = url.split('?')
  return queryString.split('&').reduce((result, item) => {
    const [key, value] = item.split('=')
    if (key) result[key] = decodeURIComponent(value || '')
    return result
  }, {})
}
const pageRows = (rows, params) => {
  const page = Math.max(1, Number(params.index || 1))
  const size = Math.min(200, Math.max(1, Number(params.pageSize || 20)))
  return { total: rows.length, rows: rows.slice((page - 1) * size, page * size) }
}
const timestampFiltered = (rows, params, timestampField) => {
  let result = rows
  if (params.reportTimestamp) result = result.filter(item => String(item.reportTimestamp || item.sourceReportTimestamp) === String(params.reportTimestamp))
  if (params.startTimestamp) result = result.filter(item => Number(item[timestampField]) >= Number(params.startTimestamp))
  if (params.endTimestamp) result = result.filter(item => Number(item[timestampField]) <= Number(params.endTimestamp))
  return result
}
const eventFiltered = (rows, params) => {
  let result = timestampFiltered(rows, params, 'startTime')
  if (params.eventStatus) result = result.filter(item => item.eventStatus === params.eventStatus)
  if (params.targetId) result = result.filter(item => item.targetId === params.targetId)
  return result
}
const eventDetails = event => ({
  event,
  operations: state.operations[event.eventId] || Array.from({ length: 20 }, (_, index) => {
    const operationType = index === 0 ? 'AUTHORIZE' : (index % 3 === 0 ? 'CANCEL' : 'AUTHORIZE')
    const successText = operationType === 'CANCEL' ? '取消成功' : '授权成功'
    const successTextEn = operationType === 'CANCEL' ? 'Cancellation succeeded' : 'Authorization succeeded'
    const commandTimestamp = event.startTime + (index + 1) * 5000
    return {
      id: state.nextOperation++, operationType, targetId: event.targetId,
      requestId: 'req-' + event.eventId + '-' + (index + 1), operationStatus: 'ACK_OK',
      commandTimestamp, feedbackCode: 1,
      feedbackMessageZh: successText, feedbackMessageEn: successTextEn,
      feedbackTimestamp: commandTimestamp + 300
    }
  })
})

function handleGet(url) {
  if (url.indexOf('robot-server/robot/list/all') > -1) {
    return response(robotCodes.map((code, index) => ({ id: index + 1, code, name: (index + 1) + '号球', onlineStatus: true })))
  }
  if (url.indexOf('pursuit/messages') > -1) {
    const params = query(url); return response(pageRows(timestampFiltered(state.messages[params.code] || state.messages[robotCodes[0]], params, 'reportTimestamp'), params))
  }
  if (url.indexOf('pursuit/events/') > -1) {
    const eventId = decodeURIComponent(url.split('pursuit/events/')[1].split('?')[0])
    const event = Object.keys(state.events).reduce((found, code) => found || state.events[code].find(item => item.eventId === eventId), null)
    return response(event ? eventDetails(event) : null)
  }
  if (url.indexOf('pursuit/events') > -1) {
    const params = query(url); return response(pageRows(eventFiltered(state.events[params.code] || state.events[robotCodes[0]], params), params))
  }
  return null
}

function handlePost(url, body) {
  const code = body.code || robotCodes[0]
  if (url.indexOf('pursuit/authorize') > -1) {
    if ((state.events[code] || []).some(item => item.active)) return { code: 409, messageENum: 'ROBOT_WORK_STATUS_PURSUIT_FORBID_REPEAT', message: '当前已有行为拒止事件', data: null, success: false }
    const event = { eventId: 'evt-mock-' + state.nextEvent++, targetId: String(body.targetId), eventStatus: 'AUTHORIZING', active: true, pursuitState: 'DETECTING', sourceReportTimestamp: Number(body.reportTimestamp), sourceAnnotatedImageUrl: fixtureImage, lastFeedbackMessageZh: '授权命令已发送，等待球侧反馈', lastFeedbackMessageEn: 'Authorization sent', startTime: Date.now(), closeTime: null, code }
    state.events[code] = [event, ...(state.events[code] || [])]
    state.operations[event.eventId] = [{ id: state.nextOperation++, operationType: 'AUTHORIZE', targetId: event.targetId, requestId: 'req-' + event.eventId, operationStatus: 'SENT', commandTimestamp: event.startTime, feedbackCode: null, feedbackMessageZh: null, feedbackMessageEn: null, feedbackTimestamp: null }]
    setTimeout(() => {
      if (!event.active) return
      event.eventStatus = 'ACTIVE'; event.pursuitState = 'TRACKING'; event.lastFeedbackMessageZh = '授权成功'
      updateOperation(event, 'ACK_OK', '授权成功', 1)
      emitSocketEvent(code, { type: 'pursuit_event', robotCode: code, data: { code, eventId: event.eventId, eventStatus: event.eventStatus, active: true, targetId: event.targetId, sourceReportTimestamp: event.sourceReportTimestamp, sourceAnnotatedImageUrl: event.sourceAnnotatedImageUrl, pursuitState: event.pursuitState, lastFeedbackCode: 1, lastFeedbackMessage: '授权成功', operationId: state.nextOperation, operationType: 'AUTHORIZE', operationStatus: 'ACK_OK', requestId: 'req-' + event.eventId } })
      emitSocketEvent(code, { type: 'pursuit_active_event', robotCode: code, data: { event } })
    }, 500)
    return response({ eventId: event.eventId, operationId: state.nextOperation++, requestId: 'req-' + event.eventId, operationStatus: 'SENT' }, '指令已下发，等待球侧反馈', 'COMMAND_SENT')
  }
  if (url.indexOf('pursuit/cancel') > -1) {
    const event = (state.events[code] || []).find(item => item.eventId === body.eventId) || (state.events[code] || []).find(item => item.active)
    if (!event || !event.active) return { code: 409, messageENum: 'PURSUIT_EVENT_NOT_FOUND', message: '没有当前活跃事件', data: null, success: false }
    if (event) {
      event.eventStatus = 'CANCELLING'; event.lastFeedbackMessageZh = '取消命令已发送，等待球侧反馈'
      setTimeout(() => {
        event.eventStatus = 'CANCELED'; event.active = false; event.closeTime = Date.now(); event.lastFeedbackMessageZh = '取消成功'; event.pursuitState = 'TRACKING'
        updateOperation(event, 'ACK_OK', '取消成功', 1)
        emitSocketEvent(code, { type: 'pursuit_event', robotCode: code, data: { code, eventId: event.eventId, eventStatus: 'CANCELED', active: false, targetId: event.targetId, sourceReportTimestamp: event.sourceReportTimestamp, sourceAnnotatedImageUrl: event.sourceAnnotatedImageUrl, pursuitState: event.pursuitState, lastFeedbackCode: 1, lastFeedbackMessage: '取消成功', operationId: state.nextOperation, operationType: 'CANCEL', operationStatus: 'ACK_OK', requestId: 'req-cancel-' + event.eventId } })
        emitSocketEvent(code, { type: 'pursuit_active_event', robotCode: code, data: { event: { ...event, active: false, eventStatus: 'CANCELED' }, closedEventId: event.eventId, closedEventStatus: 'CANCELED' } })
      }, 500)
    }
    return response({ eventId: event && event.eventId, operationId: state.nextOperation++, requestId: 'req-cancel-' + Date.now(), operationStatus: 'SENT' }, '取消指令已下发，等待球侧反馈', 'COMMAND_SENT')
  }
  return response(null)
}

export function installPursuitMock() {
  if (!pursuitMockEnabled || axios.__pursuitMockInstalled) return
  const adapter = axios.defaults.adapter
  axios.defaults.adapter = config => {
    const url = config.url || ''
    const isPursuit = /(?:robot-server\/robot\/list\/all|pursuit\/messages|pursuit\/events|pursuit\/authorize|pursuit\/cancel)/.test(url)
    if (!isPursuit) return adapter(config)
    const data = config.method === 'post' ? handlePost(url, typeof config.data === 'string' ? JSON.parse(config.data) : (config.data || {})) : handleGet(url)
    // Keep the fixture source readable while returning a browser-renderable image URL.
    const renderableData = JSON.parse(JSON.stringify(data).replace(/\[image omitted\]/g, 'data:image/svg+xml;charset=UTF-8,'))
    return Promise.resolve({ data: renderableData, status: 200, statusText: 'OK', headers: {}, config })
  }
  axios.__pursuitMockInstalled = true
}

export function createPursuitMockSocket(onMessage) {
  if (!pursuitMockEnabled) return null
  let closed = false
  let code = robotCodes[0]
  const send = raw => {
    let message; try { message = typeof raw === 'string' ? JSON.parse(raw) : raw } catch (e) { return }
    if (message.type === 'subscribe' && message.robotCode) {
      code = message.robotCode
      socketRef.code = code
      onMessage({ type: 'subscribe_success', robotCode: code, data: { code } })
      const current = (state.events[code] || []).find(item => item.active) || null
      if (code !== activeOnlyRobotCode) {
        onMessage({ type: 'work_condition', robotCode: code, data: { code, status: current || code === conditionOnlyRobotCode ? 6 : 1, timestamp: Date.now() } })
      }
      onMessage({ type: 'pursuit_active_event', robotCode: code, data: { event: current } })
      if (current) onMessage({ type: 'pursuit_state', robotCode: code, data: { code, eventId: current.eventId, eventStatus: current.eventStatus, state: current.pursuitState, targetId: current.targetId, reportTimestamp: current.sourceReportTimestamp } })
    }
  }
  const socket = { readyState: 1, code, closed: false, onMessage, send, close () { closed = true; this.closed = true; clearTimeout(timer); this.readyState = 3; const index = socketRegistry.indexOf(this); if (index > -1) socketRegistry.splice(index, 1); if (this._onclose) this._onclose() }, set onclose (handler) { this._onclose = handler } }
  const socketRef = socket
  socketRegistry.push(socket)
  const timer = setTimeout(() => {
    if (closed) return
    onMessage({ type: 'init_success', robotCode: code, data: {} })
    const current = (state.events[code] || []).find(item => item.active) || null
    if (current) {
      if (code !== activeOnlyRobotCode) {
        onMessage({ type: 'work_condition', robotCode: code, data: { code, status: 6, timestamp: Date.now(), onlineStatus: true } })
      }
      onMessage({ type: 'pursuit_active_event', robotCode: code, data: { event: current } })
      onMessage({ type: 'pursuit_state', robotCode: code, data: { code, eventId: current.eventId, eventStatus: current.eventStatus, state: current.pursuitState, targetId: current.targetId, reportTimestamp: current.sourceReportTimestamp } })
    }
  }, 10)
  return socket
}

// Development-only SSF feed so the global notification flow can be verified
// without connecting to the production message service.
export function createPursuitSsfMockSocket(onMessage) {
  if (!pursuitMockEnabled) return null
  let closed = false
  const code = robotCodes[0]
  const reportTimestamp = state.messages[code] && state.messages[code][0] && state.messages[code][0].reportTimestamp
  const targetIds = state.messages[code] && state.messages[code][0]
    ? state.messages[code][0].targets.map(target => target.targetId)
    : ['ab6c5675-244a-463a-9785-2f9fa00699a6']
  const emit = message => { if (!closed) onMessage(message) }
  const timers = []
  // Show the short event reminder first, then the detection detail notification
  // after it closes so both notification variants can be inspected in sequence.
  timers.push(setTimeout(() => emit({ type: 'pursuit_detection', robotCode: code, data: { code, reportTimestamp, targetIds, annotatedImageUrl: fixtureImage } }), 5000))
  timers.push(setTimeout(() => emit({ type: 'pursuit_state', robotCode: code, data: { code, eventId: 'evt-mock-1-1', targetId: targetIds[0], state: 'TRACKING', reportTimestamp, sourceAnnotatedImageUrl: fixtureImage } }), 2600))
  timers.push(setTimeout(() => emit({ type: 'pursuit_event', robotCode: code, data: { code, eventId: 'evt-mock-1-1', targetId: targetIds[0], eventStatus: 'ACTIVE', state: 'TRACKING', operationType: 'AUTHORIZE', operationStatus: 'ACK_OK', lastFeedbackMessageZh: mockOfflineFeedbackZh, lastFeedbackMessageEn: mockOfflineFeedbackEn } }), 1200))
  return {
    readyState: 1,
    socketFlag: true,
    send () {},
    close () {
      closed = true
      timers.forEach(timer => clearTimeout(timer))
      this.readyState = 3
      this.socketFlag = false
      if (this._onclose) this._onclose()
    },
    set onclose (handler) { this._onclose = handler }
  }
}
